// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"1b776f9a","676":"8a2e0243","790":"ca289169"}[chunkId] + ".chunk.js";
};